import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';

import { GrowlManager } from './growl.manager';
import { Locale } from './../service/locale.service';

@Injectable()
export class SpoHttpInterceptor implements HttpInterceptor {

	private error401 		= 'dummy';
	private error403 		= 'dummy';
	private error0 			= 'dummy';
	private unknown_error 	= 'dummy';
	private language 		= 'IT';

	constructor(private growlManager: GrowlManager, private locale: Locale) {}

/*
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		console.log("intercepted request ... ");

		// Clone the request to add the new header.
		//const authReq = req.clone({ headers: req.headers.set("headerName", "headerValue")});

		//console.log("Sending request with new header now ...");

		//send the newly created request
		return next.handle(req)
			.catch((error, caught) => {
				//intercept the respons error and displace it to the console
				console.log("Error Occurred");
				console.log(error);
				//return the error to the method that called it
				return Observable.throw(error);
			}) as any;
	}
*/
	init(){
		this.error401 		= this.locale.getTerms().common.messages.HTTP_401_UNAUTHORIZED_USER;
		this.error403 		= this.locale.getTerms().common.messages.NO_RIGHT;
		this.error0 		= this.locale.getTerms().common.messages.NO_CONNECTION;
		this.unknown_error 	= this.locale.getTerms().common.messages.SERVER_ERROR;
		this.language 		= this.locale.getPreferredLanguage(); 		
	}	

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    	
    	console.log("intercepted request ... ");

    	this.init();

		const newReq = req.clone( { headers: req.headers.set( "Accept-Language", this.language ) } );	

        return next.handle(newReq).do(event => {}, err => {
            if (err instanceof HttpErrorResponse) {
		        switch(err.status){
		        	// mock error handling
		            case 485:{

		                break;
		             }
		            //UnAuthorized
		            case 401:{
						this.growlManager.showError(this.error401);
		                break;
		             }
		            //UnAuthorized
		            case 403:{
						this.growlManager.showError(this.error403);
		                break;
		             }
		            //No connection
		            case 500:{
						this.growlManager.showError(err.message);
		                break;
		            }    
		            //No connection
		            case 0:{
						this.growlManager.showError(this.error0);
		                break;
		            }  
		            //Generic Unknown
		            default: {
		            	this.growlManager.showError(this.unknown_error);
		                break;
		        	}
		        }
            }else{
            	console.log(err);
            }          
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/manager/http.interceptor.ts